<template>
  <div>
    <a-tabs type="card">
      <a-tab-pane key="1" tab="网站地图">
        <WebsiteMap />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import WebsiteMap from './websiteMap/websiteMap.vue'
import LabelMap from './labelMap/labelMap.vue'

export default {
  name: '',
  components: {
    WebsiteMap,
    LabelMap,
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
</style>
